// extracted by mini-css-extract-plugin
export default {"responses":"E7TG3w","response":"PZ4YQl"};